import { useEffect, useRef, useState } from 'react'
import { useRouter } from 'next/router'
import { OrderEnum, PaginationInterface } from 'shared/types/swr-pagination-interface'
import EmptyList from '../../profile/manage-suscriptions/components/table/empty-list'
import { useTemplates } from '../hooks/use-templates'
import { TemplatesFilterInterface } from '../types/templates-filter-interface'
import TemplatesListItem from './templates-list-item'
import TemplatesListSkeleton from './templates-list-skeleton'
import TemplatesPagination, { TemplatesLimitType } from './templates-pagination'

interface TemplatesListProps {
  filter: TemplatesFilterInterface
  onChangeCategory: (category: number | null) => void
}

const TemplatesList = ({ filter, onChangeCategory }: TemplatesListProps) => {
  const { locale } = useRouter()

  const [pagination, setPagination] = useState<PaginationInterface>({
    startFromId: undefined,
    order: OrderEnum.next,
  })

  const [limit, setLimit] = useState<TemplatesLimitType>(15)

  const { templates } = useTemplates({ limit, pagination, filter })
  const templatesRef = useRef(null)

  useEffect(() => {
    setPagination({ order: OrderEnum.next, startFromId: undefined })
    setLimit(15)
  }, [filter, locale, setLimit, setPagination])

  return templates ? (
    <div className={'flex w-full flex-col gap-3'}>
      {templates.items.length !== 0 ? (
        <div
          ref={templatesRef}
          className="grid grid-cols-1 gap-10 lg:grid-cols-2 lg:gap-8 xl:grid-cols-3 xl:gap-8"
        >
          {templates.items.map(template => (
            <TemplatesListItem
              selectedCategory={filter.category}
              onChangeCategory={onChangeCategory}
              key={template.id}
              template={template}
            />
          ))}
        </div>
      ) : (
        <EmptyList />
      )}
      <TemplatesPagination
        templatesRef={templatesRef}
        data={templates}
        limiter={{ limit, setLimit }}
        paginator={{ pagination, setPagination }}
      />
    </div>
  ) : (
    <TemplatesListSkeleton />
  )
}

export default TemplatesList
